import { getApiBase, safeJson } from "./http";
import type { PersonLite } from "../types";

export const fetchPeopleApi = async (): Promise<PersonLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/persons?page=1&pageSize=200`);
    if (!res.ok) throw new Error(`Kunne ikke hente personer (${res.status})`);

    const data = await safeJson<any>(res);

    const arr = Array.isArray(data)
        ? data
        : Array.isArray(data?.items)
            ? data.items
            : Array.isArray(data?.Items)
                ? data.Items
                : [];

    const mapped: PersonLite[] = arr
        .map((p: any) => {
            const rawId =
                p.personID ??
                p.PersonID ??
                p.personId ??
                p.PersonId ??
                p.id ??
                p.ID;

            const personID = Number(rawId);

            const firstName = p.firstName ?? p.FirstName ?? "";
            const lastName = p.lastName ?? p.LastName ?? "";

            const fullName = String(
                p.fullName ??
                p.FullName ??
                p.name ??
                p.Name ??
                `${firstName} ${lastName}`
            ).trim();

            const functions = p.functions ?? p.Functions ?? [];
            const functionName = Array.isArray(functions)
                ? functions.join(", ")
                : (p.functionName ?? p.FunctionName ?? p.function ?? p.Function ?? undefined);

            return {
                personID,
                fullName: fullName || `Person #${Number.isFinite(personID) ? personID : "?"}`,
                email: p.email ?? p.Email ?? undefined,
                functionName,
            };
        })
        .filter((x: PersonLite) => Number.isFinite(x.personID) && x.personID > 0);

    return mapped;
};